import { render, staticRenderFns } from "./cartList.vue?vue&type=template&id=4131ec2e&"
import script from "./cartList.vue?vue&type=script&lang=js&"
export * from "./cartList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports